var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:{ button: _vm.asButton, pulse: _vm.pulse },attrs:{"href":_vm.url,"target":_vm.target,"rel":"noopener"},on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }